import axios from 'axios';

const fetchMission = async (id) => axios.get(`/missions/${id}`);

const deleteMission = async (id) => axios.delete(`/missions/${id}`);

const downloadMission = async (id, downloadObstacles) =>
  axios.get(`/missions/${id}/download`, {
    responseType: 'blob',
    params: {
      downloadObstacles,
    },
  });

const exportMission = async (id) => axios.get(`/missions/${id}/export`, { responseType: 'blob' });

const fetchMissions = async (params) => axios.get(`/missions`, { params });

const fetchMissionObstacles = async (mission) => axios.post(`/missions/obstacles`, mission);

const fetchMissionAirports = async (mission) => axios.post('/missions/airports', mission);

const createMission = async (mission) => axios.post(`/missions`, mission);

const updateMission = async (id, mission) => axios.put(`/missions/${id}`, mission);

const validateMissionConfiguration = async (request) => axios.post('/missions/validate', request, { headers: { 'Content-Type': 'multipart/form-data' } });

export default {
  fetchMission,
  deleteMission,
  downloadMission,
  exportMission,
  fetchMissions,
  fetchMissionObstacles,
  fetchMissionAirports,
  createMission,
  updateMission,
  validateMissionConfiguration,
};
